import { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export const useEventDetails = () => {
  const { getValues, register, watch, setValue } = useFormContext()
  const academyRequired = watch('academyRequired')
  const academyId = getValues('academyId') || ''

  const [isAcademyEvent, setIsAcademyEvent] = useState(academyRequired)

  useEffect(() => {
    register('academyRequired')
  }, [register])

  useEffect(() => {
    setIsAcademyEvent(academyRequired)
  }, [academyRequired])

  return {
    getValues,
    register,
    watch,
    setValue,
    academyRequired,
    academyId,
    isAcademyEvent,
    setIsAcademyEvent,
  }
}

export default useEventDetails
